export default __webpack_public_path__ + "static/media/ios-device.1cf8c8ac.png";